import * as Sentry from "@sentry/vue";
import Vue, { createApp, markRaw } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { createI18n } from 'vue-i18n';
import { createPinia } from 'pinia';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import routes from './routes';
const pinia = createPinia();

// Import Bootstrap an BootstrapVue CSS files (order is important)
import './app.scss';
import translations from './i18n/translations.json';
import { useUserStore } from '@stores/User';
import Application from '@components/Application.vue';
import { useAppStore } from '@stores/App';
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin);

const applicationInstance = createApp(Application);

const i18n = createI18n({
    locale: document.querySelector('html').lang,
    messages: translations,
    fallbackLocale: 'en',
});

const router = createRouter({
    history: createWebHistory(),
    routes, // short for `routes: routes`
});

pinia.use(({ store }) => {
    store.$router = markRaw(router);
});

applicationInstance.use(pinia);

if (parseFloat(process.env.MIX_SENTRY_SAMPLE_RATE)) {
    Sentry.init({
        dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
        environment: process.env.MIX_SENTRY_ENVIRONMENT,
        integrations: [Sentry.browserTracingIntegration({router}), Sentry.replayIntegration()],
        tracesSampleRate: process.env.MIX_SENTRY_SAMPLE_RATE,

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', 'my.newport.localhost', 'https://livetest-my.newport.se/api'],

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: process.env.MIX_SENTRY_ERROR_SAMPLE_RATE,
    });
}

setInterval(() => {
    const user = useUserStore();
    user?.intervalCheck();
}, 10000)

// Define a global navigation guard
router.beforeEach((to, from, next) => {
    const app = useAppStore();
    app.pageClasses.clear();

    if (to?.meta?.public) {
        return next();
    }

    const user = useUserStore();
    const loggedIn = user.isLoggedIn();

    if  (loggedIn && to.query.redirectTo) {
        window.location.href = to.query.redirectTo;
    }

    // Check if the route is not the login route
    if (to.path !== '/login') {
        user.last_login_path = to.path;

        // If not logged in, redirect to login page
        if (!loggedIn) {
            user.redirect_to = to;
            return next('/login');
        } else {
            if (user.needsRefresh()) {
                user.refresh();
            }
            return next(); // Proceed to the requested route
        }
    }

    if (loggedIn) {
        return next('/account/wedding-list/create'); // if logged in lets redirect to account
    }

    if (to.path === '/login') {
        return next(); // Continue to the login route
    }
});

const app = useAppStore();
app.warmUp();
applicationInstance
    .use(i18n)
    .use(router)
    .mount('#vue-root');
